import { h } from '@atomify/jsx';
import { ButtonA } from '@atoms/button/button';
import { isNetherlands } from '@utilities/is-netherlands';

interface HotjarSurveyBlockInterface {
    intro: string;
    surveyUrl: string;
    ctaLabel?: string;
    classes?: string;
}

const HotjarSurveyBlock = (data: HotjarSurveyBlockInterface) => {
    const { intro, surveyUrl, ctaLabel = 'Start enquête', classes } = data;
    return isNetherlands() ? (
        <div class={`c-hotjar-survey ${classes}`.trim()}>
            <p class="hotjar-survey__intro">{intro}</p>
            <ButtonA classes="hotjar-survey__cta" url={surveyUrl}>
                {ctaLabel}
            </ButtonA>
        </div>
    ) : null;
};

export { HotjarSurveyBlock };
